import React, { Component } from 'react'

import TablaDetalleEspacioPorCerealLinea12 from '../../detallesEspacioPorCereal/detalleEspacioPorCereal12/containers/TablaDetalleEspacioPorCerealLinea12'
import TablaDetalleEspacioPorCerealLinea3 from '../../detallesEspacioPorCereal/detalleEspacioPorCereal3/containers/TablaDetalleEspacioPorCerealLinea3'
import TablaDetalleEspacioPorCerealLinea4 from '../../detallesEspacioPorCereal/detalleEspacioPorCereal4/containers/TablaDetalleEspacioPorCerealLinea4'
import TablaDetalleEspacioPorCerealLinea5 from '../../detallesEspacioPorCereal/detalleEspacioPorCereal5/containers/TablaDetalleEspacioPorCerealLinea5'
import TablaDistribucionEspacioPorCereal from '../../shared/distribucionEspacioPorCereal/containers/TablaDistribucionEspacioPorCereal'

export class EspacioPorCerealDetallesView extends Component {
  render () {
    return (
      <>
        <TablaDistribucionEspacioPorCereal conLink={false} />
        <TablaDetalleEspacioPorCerealLinea12 />
        <TablaDetalleEspacioPorCerealLinea3 />
        <TablaDetalleEspacioPorCerealLinea4 />
        <TablaDetalleEspacioPorCerealLinea5 />
      </>
    )
  }
}
